import {log, Cookies} from './environment.js';

export let text;
export let json;
export let blob;
export let post;
export let del;

function request(method, url, options) {
	const xhr = new XMLHttpRequest();

	let protocol = location.protocol;
	if (url.indexOf('://') > 0) {
		protocol = /^([\w-]+:)\/\//.test(url) ? RegExp.$1 : protocol;
	}

	xhr.onload = function () {
		const isValid =
			xhr.status >= 200 && xhr.status < 300 ||
			xhr.status === 0 && protocol === 'file:';

		if (isValid && options.onLoad) {
			options.onLoad(xhr.response);
		} else if (!isValid && options.onError) {
			const err = new Error('Network request failed');
			err.xhr = xhr;
			options.onError(err);
		}

		if (!isValid) {
			log("xhr request invalid", {
				level: 'warning',
				extra: {url, options, method, status: xhr.status},
				fingerprint: ['loading', 'xhr', 'invalid'],
			});
		}
	};
	xhr.onerror = () => {
		log("xhr request failed", {
			level: 'warning',
			extra: {url, options, method},
			fingerprint: ['loading', 'xhr', 'fail'],
		});
		const err = new Error('Network request failed');
		err.xhr = xhr;
		return options.onError && options.onError(err);
	};

	xhr.open(method, url);
	xhr.withCredentials = options.withCredentials;
	if (options.headers) {
		Object.keys(options.headers)
			.forEach(k => xhr.setRequestHeader(k, options.headers[k]));
	}

	xhr.responseType = options.responseType || 'text';
	xhr.send(options.data || {});

	if (options.onSend) {
		options.onSend(xhr);
	}

	return xhr;
}

if (IS_BROWSER) {
	text = function text(url, options = {}) {
		return new Promise((resolve, reject) => {
			options.onLoad = resolve;
			options.onError = reject;
			request('GET', url, options);
		});
	};

	json = function json(url, options = {}) {
		const headers = options.headers = options.headers || {};
		headers.Accept = 'application/json';
		return text(url, options).then(JSON.parse);
	};

	blob = function blob(url, options = {}) {
		options.responseType = 'blob';
		return text(url, options);
	};

	post = function post(url, data, options = {}) {
		const headers = options.headers = options.headers || {};
		headers.Accept = 'application/json';
		headers['X-CSRFToken'] = Cookies.get('csrftoken');

		if (typeof data === "string") {
			headers['Content-Type'] = 'application/x-www-form-urlencoded';
			options.data = data;
		} else {
			headers['Content-Type'] = 'application/json';
			options.data = JSON.stringify(data);
		}
		return new Promise((resolve, reject) => {
			options.onLoad = resolve;
			options.onError = reject;
			request(options.method || 'POST', url, options);
		}).then(d => d && JSON.parse(d));
	};

	del = function del(url, data, options = {}) {
		return post(url, data, Object.assign(options, {method: 'DELETE'}));
	};
} else {
	const wrap = (url, options) => {
		const label = `-> ${url}`;
		console.time(label);

		const headers = new Headers();
		headers.append('User-Agent', 'PagestripSSR/1.0');
		const init = { headers };

		if (options.headers) {
			Object.keys(options.headers)
				.forEach(k => headers.append(k, options.headers[k]));
		}

		//console.log(JSON.stringify(init));

		return fetch(url, init).then(
			res => {
				console.timeEnd(label);
				return res;
			},
			err => {
				console.timeEnd(label);
				throw err;
			});
	};
	text = (url, options = {}) => wrap(url, options).then(res => res.text());
	json = (url, options = {}) => wrap(url, options).then(res => res.json());
}



// WEBPACK FOOTER //
// ./lib/xhr.js